import React, { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import MobileMenu from "../MobileMenu/Index";

const Index = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!isMenuOpen) {
        setIsScrolled(window.scrollY > 0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isMenuOpen]);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleSmoothScroll = (e) => {
    e.preventDefault();
    const targetId = e.currentTarget.getAttribute("href").slice(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
      setIsMenuOpen(false);
    }
  };

  return (
    <div>
      <header
        className={`fixed top-0 left-1/2 transform -translate-x-1/2 w-full shadow z-10 transition-all duration-300 ${
          isScrolled
            ? "bg-primary py-4 max-w-screen-md md:mt-3 px-5 md:rounded justify-center items-center"
            : "bg-white py-4 px-8 justify-center items-center"
        }`}
      >
        <div className="container mx-auto flex justify-between items-center">
          <a
            href="#hero"
            className="flex items-center space-x-2"
            onClick={handleSmoothScroll}
          >
            <img
              src={
                isScrolled
                  ? "./Assets/images/logo_koyu.png"
                  : "./Assets/images/logo_beyaz.png"
              }
              alt="Commerce Minder Logo"
              className={`h-10 transition-all duration-300 ${
                isScrolled ? "h-8" : "h-10"
              }`}
            />
            <h3
              className={`text-lg font-bold transition-all duration-300 ${
                isScrolled ? "text-white" : "text-primary"
              }`}
            >
              CommerceMinder
            </h3>
          </a>
          <nav className="hidden md:flex flex-1 text-center justify-center">
            <ul className="inline-flex space-x-8">
              <li>
                <a
                  href="#features"
                  className={`hover:text-blue-400 transition-colors duration-300 ${
                    isScrolled ? "text-white" : "text-black"
                  }`}
                  onClick={handleSmoothScroll}
                >
                  Features
                </a>
              </li>
              <li>
                <a
                  href="#about"
                  className={`hover:text-blue-400 transition-colors duration-300 ${
                    isScrolled ? "text-white" : "text-black"
                  }`}
                  onClick={handleSmoothScroll}
                >
                  About
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className={`hover:text-blue-400 transition-colors duration-300 ${
                    isScrolled ? "text-white" : "text-black"
                  }`}
                  onClick={handleSmoothScroll}
                >
                  Contact
                </a>
              </li>
            </ul>
          </nav>
          <p className={`hidden md:block ${isScrolled ? "text-white" : "text-primary"}`}>The New Mind of Commerce</p>
          <button
            className="md:hidden text-2xl focus:outline-none"
            onClick={toggleMenu}
          >
            {isMenuOpen ? (
              <FaTimes
                className={`${isScrolled ? "text-white" : "text-black"}`}
              />
            ) : (
              <FaBars
                className={`${isScrolled ? "text-white" : "text-black"}`}
              />
            )}
          </button>
        </div>
        {isMenuOpen && <MobileMenu isMenuOpen={isMenuOpen} isScrolled={isScrolled} handleSmoothScroll={handleSmoothScroll}/>}
      </header>
      <div className="pt-20"></div>
    </div>
  );
};

export default Index;
